export default "__VITE_ASSET__38zw6E4W__"